import { IPutAfterConfirmingBookingWorkflowRequest } from '@/types/workflows/IPutAfterConfirmingBookingWorkflowRequest';
import { Box, Divider, FormControl, FormLabel, Heading, Select } from '@chakra-ui/react';
import { t } from 'i18next';
import { UseFormReturn } from 'react-hook-form';

interface IProps {
	form: UseFormReturn<IPutAfterConfirmingBookingWorkflowRequest, any>;
}

export default function TriggerSection(props: IProps) {
	return (
		<Box bg="white" p={4} borderRadius="md" borderColor="gray.100" borderWidth={1}>
			<Box display="grid" gridTemplateColumns="1fr" justifyContent="space-between" alignItems="center">
				<Heading size="md">{t('Trigger')}</Heading>
			</Box>
			<Divider my={4} />

			<FormControl>
				<FormLabel>{t('When this happens')}</FormLabel>
				<Select {...props.form.register('type')}>
					<option value="PutAfterConfirmingBookingWorkflowRequest">A booking is confirmed</option>
					<option value="EVENT_CANCELLED">A booking is cancelled</option>
				</Select>
			</FormControl>
		</Box>
	);
}
